







































































































































































































import { SfLoader, SfImage, SfButton } from '~/components/StorefrontUi';
import BlikCode from '~/modules/checkout/components/Summary/BlikCode.vue';
import CheckoutLayout from '~/modules/checkout/layouts/checkout.vue';
import UserAddressDetails from '~/components/UserAddressDetails.vue';
import SummaryProducts from '~/modules/checkout/components/SummaryProducts.vue';
import {
  ref,
  computed,
  defineComponent,
  useRouter,
  useContext,
  onMounted,
} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import {
  getPaymentIconsByCode,
  getShippingIconByTitle,
} from '~/helpers/getShippingIconByTitle';
import type { PlaceOrderOutput } from '~/modules/GraphQL/types';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import useMakeOrder from '~/modules/checkout/composables/useMakeOrder';
import usePaymentProvider from '~/modules/checkout/composables/usePaymentProvider';
import useCart from '~/modules/checkout/composables/useCart';
import { useUser } from '~/modules/customer/composables/useUser';
import { removeItem, getItem, setItem } from '~/helpers/asyncLocalStorage';
import {
  getMethodCode,
  PayuMethodCodesEnum,
} from '~/helpers/payuMethods';
import { IconSingleArrowLeft } from '~/components/General/icons';
import { usePayuMethodsStore } from '../../stores/payuMethods';

export default defineComponent({
  name: 'SummaryStep',
  components: {
    SectionHeading: () => import(
      /* webpackPrefetch: true */ '~/modules/checkout/components/SectionHeading.vue'
    ),
    SummaryProducts,
    SfButton,
    SfLoader,
    SfImage,
    CheckoutLayout,
    CheckoutAside: () => import('~/modules/checkout/components/CheckoutAside.vue'),
    UserAddressDetails,
    BlikCode,
    IconSingleArrowLeft,
    // VsfPaymentProvider: () => import('~/modules/checkout/components/VsfPaymentProvider.vue'),
  },
  setup() {
    const order = ref<PlaceOrderOutput>(null);
    const { cart, load, setCart } = useCart();
    const { isAuthenticated } = useUser();
    const { make } = useMakeOrder();
    const { save: savePaymentProvider } = usePaymentProvider();
    const { app, i18n } = useContext();
    const router = useRouter();
    const { payuMethods } = usePayuMethodsStore();

    const userType = ref('');
    const userTypeVariants = ref({
      company: {
        text: i18n.t('Company'),
        icon: addBasePath('/icons/briefcase-gray.svg'),
      },
      private: {
        text: i18n.t('Private individual'),
        icon: addBasePath('/icons/user-gray.svg'),
      },
    });
    const currentUserTypeVariant = computed(
      () => userTypeVariants.value[userType.value] || {},
    );

    const blikCode = ref('');
    const isBlikCodeValid = computed(() => {
      const normalizedCode = blikCode.value.trim();
      return (
        normalizedCode.length === 6 && !Number.isNaN(Number(normalizedCode))
      );
    });
    const shippingTitle = computed(
      () => cartGetters.getSelectedShippingMethod(cart.value)?.method_title,
    );
    const selectedPaymentMethod = computed(() => cartGetters.getSelectedPaymentMethod(cart.value));
    const isSelectedPaymentBlik = computed(
      () => selectedPaymentMethod.value?.code
        === PayuMethodCodesEnum.PAYU_GATEWAY_BLIK,
    );
    const shouldDisableProcessOrderButton = computed(
      () => isSelectedPaymentBlik.value && !isBlikCodeValid.value,
    );
    const paymentTitle = computed(() => {
      const method = selectedPaymentMethod.value;
      if (!method?.payu_additional_data) return method.title;
      if (isSelectedPaymentBlik.value) return 'Blik';
      return (
        payuMethods?.find(
          (payuMethod) => payuMethod.value === method.payu_additional_data.payu_method,
        )?.name || method.title
      );
    });
    const paymentCode = computed(() => getMethodCode(selectedPaymentMethod.value));
    const pickupAddress = computed(
      () => cartGetters.getSelectedShippingMethod(cart.value)?.pickup_address,
    );

    const processOrder = async () => {
      order.value = await make();
      if (!order.value) return;
      const { postcode } = cart.value.billing_address;
      const { email } = cart.value;
      setCart(null);
      app.$vsf.$magento.config.state.removeCartId();
      await load();
      await removeItem('checkout');
      if (!isAuthenticated.value) {
        await setItem('user-order-data', { email, postcode });
      }

      const redirectUri = order.value?.redirect_uri;
      if (redirectUri) {
        window.open(redirectUri, '_self');
      } else if (isAuthenticated.value) {
        const thankYouRoute = app.localeRoute({
          name: 'thank-you',
          query: {
            order_increment_id: order.value.order.order_number,
          },
        });
        await router.push(thankYouRoute);
      } else {
        const thankYouRoute = app.localeRoute({
          name: 'thank-you',
          query: {
            order_increment_id: order.value.order.order_number,
            email,
            postcode,
          },
        });
        await router.push(thankYouRoute);
      }
    };
    const processOrderLoading = ref(false);
    const handleProcessOrder = async () => {
      if (processOrderLoading.value) return; // prevent double/etc click
      processOrderLoading.value = true;
      if (isSelectedPaymentBlik.value) {
        if (!isBlikCodeValid.value) return;
        await savePaymentProvider({
          paymentMethod: {
            code: selectedPaymentMethod.value.code,
            // @ts-ignore
            payu_additional_data: {
              payu_method_type:
                selectedPaymentMethod.value.payu_additional_data
                  .payu_method_type,
              payu_method: blikCode.value,
              base_return_url:
                selectedPaymentMethod.value.payu_additional_data
                  .base_return_url,
            },
          },
        });
      }
      await processOrder();
      processOrderLoading.value = false;
    };
    const products = computed(() => cartGetters.getItems(cart.value));
    const isAllProductsVirtual = computed(() => cartGetters.isCartVirtual(cart.value));

    onMounted(async () => {
      const checkoutDataFromLS = await getItem('checkout');
      userType.value = checkoutDataFromLS['user-type']
        ? checkoutDataFromLS['user-type']
        : '';
    });
    return {
      cart,
      addBasePath,
      getPaymentIconsByCode,
      getShippingIconByTitle,
      shippingTitle,
      currentUserTypeVariant,
      cartGetters,
      processOrderLoading,
      processOrder,
      handleProcessOrder,
      products,
      isAllProductsVirtual,
      paymentTitle,
      paymentCode,
      isSelectedPaymentBlik,
      blikCode,
      selectedPaymentMethod,
      shouldDisableProcessOrderButton,
      pickupAddress,
    };
  },
});
